export default {
  noDataToCompare: 'Nie wybrano żadnej pracy do porównania',
};
